import axios from 'axios';
import toast from 'react-hot-toast';

import { configSetting } from '../../config';

const useDownLoadBinQRCode = () => {
  const getDownLoadBinQRCode = (binId: any) => {
    const url = `warehouse-service/api/v1/bins/qr/${binId}`;
    const apiUrl = `${configSetting.apiUrl}${url}`;
    axios
      .get(apiUrl, {
        responseType: 'blob',
      })
      .then((obj) => {
        const url = URL.createObjectURL(obj.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'bin barcode.png';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);

        toast.success('Downloading bin barcode');
      })
      .catch((err) => console.error(err));
  };

  return { getDownLoadBinQRCode };
};
export default useDownLoadBinQRCode;
